module.exports = {
	"next": "suivant",
	"skip": "Créer directement votre Cozy",
	"cancel": "annuler",
	"back": "retour",
	"sign up": "s'enregistrer",
	"add email": "ajouter un compte email",
	"welcome": "c'est parti !",
	"confirm": "valider",
	"user missing properties": "Désolé mais cet utilisateur n'existe pas.",
	"step welcome user": "Bienvenue %{name}!",
	"step welcome anon": "Bienvenue",
	"step welcome logout": "Ce n'est pas vous ?",
	"step welcome congrats": "Félicitations, grâce à vous, vos données personnelles ont un endroit bien à elles, directement dans votre Cozy.",
	"step welcome next": "Continuer",
	"step agreement title": "Conditions générales d'utilisation",
	"step agreement subtitle": "Pour utiliser votre Cozy vous devez avoir lu et accepté nos conditions d'utilisation. Si, comme nous, vous ne les lisez jamais, voici un résumé de ces dernières :",
	"step agreement element 0": "Contrôle et responsabilités sur vos données, chez vous !",
	"step agreement element 1": "Nous sommes aux petits soins pour vous et votre cozy...",
	"step agreement element 2": "… sauf si vous faites n’importe quoi avec Cozy ou vos données",
	"step agreement element 3": "Décidez qui traite et exploite vos données et dans quel but",
	"step agreement element 4": "Personne (pas même nous) ne regarde les données dans votre Cozy",
	"step agreement element 5": "On a quelques infos sur vous, pour raisons légales ou de qualité de service uniquement",
	"step agreement stats": "J'autorise Cozy à récupérer des données anonymement",
	"step agreement description 1": "Les conditions générales complètes sont accessibles",
	"step agreement description 2": "En cliquant sur le bouton \"Accepter\", vous confirmer avoir pris connaissance de ces précédentes et les acceptez.",
	"step agreement description link": "à cette adresse.",
	"step agreement next": "Accepter",
	"step preset": "réglages",
	"step import": "importer des données",
	"step email settings": "configurer votre email",
	"preset email": "email",
	"preset email tip": "Cette adresse email sera utilisée pour vous envoyer un message lors d'une récupération de mot de passe.",
	"preset name": "nom",
	"step password empty": "Vous devez renseigner votre mot de passe.",
	"step password too weak": "Votre mot de passe est trop simple. Il est recommandé d'utiliser des majuscules, des chiffres, des caractères spéciaux et/ou un mot de passe plus long.",
	"step password title": "Sécurisez votre mot de passe",
	"step password label": "mot de passe",
	"step password input placeholder": "Par exemple: \"dEj875ghj9273;eR\"",
	"step password submit": "confirmer",
	"step password show": "Afficher le mot de passe",
	"step password hide": "Cacher le mot de passe",
	"step password description": "Votre mot de passe doit être complexe afin d'empêcher les personnes malveillantes d'accéder à votre espace. Il est recommandé d'utiliser des majuscules, des chiffres et des caractères spéciaux.",
	"step password server error": "Une erreur s'est produite, votre mot de passe n'a pas pu être enregistré.",
	"step infos title": "Compléter votre cozy",
	"step infos description": "Certaines informations sont nécessaires pour la bonne configuration de votre Cozy.",
	"step infos public_name label": "NOM D'UTILISATEUR.TRICE",
	"step infos public_name placeholder": "The public display name your Cozy will use to speak with you.",
	"step infos email label": "Email",
	"step infos email placeholder": "Afin de pouvoir vous contacter en cas de perte de mot de passe.",
	"step infos timezone label": "Fuseau horaire",
	"step infos timezone placeholder": "Votre fuseau horaire permet d'afficher correctement votre calendrier.",
	"step infos submit": "Confirmer",
	"step infos fetch data error": "Impossible de récupérer les données du serveur.",
	"missing public_name": "Vous devez préciser votre nom d'utilisateur.trice.",
	"missing email": "Vous devez préciser votre email.",
	"invalid email format": "Votre adresse email ne semble pas correcte.",
	"missing timezone": "Vous devez préciser votre fuseau horaire.",
	"invalid timezone": "Votre fuseau horaire ne semble pas correcte.",
	"step accounts title": "Votre Cozy a bien été créé !",
	"step accounts description line 1": "Désormais, nous allons vous accompagner pour connecter les services qui vous intéressent sur votre Cozy.",
	"step accounts description line 2": "Cozy vous aide à vous ré-approprier vos données, il est temps de les ajouter !",
	"step accounts next": "Parcourir",
	"myaccounts info": "Vous pouvez dès à présent accéder à votre Cozy à n'importe quel moment, en appuyant sur le bouton 'Continuer'",
	"myaccounts next": "Continuer",
	"step confirmation title": "Bienvenue dans votre cloud personnel !",
	"step confirmation description line 1": "Votre cozy est désormais prêt pour vous.",
	"step confirmation description line 2": "Vous pouvez dès à présent récupérer vos données vers de nombreux services et installer les applications qui vous intéressent sur notre marché.",
	"step confirmation next": "Entrer",
	"step server error": "Une erreur est survenue pendant la sauvegarde de votre progression. Recharger la page devrait résoudre le problème.",
	"preset name tip": "Le nom sous lequel vous apparaitrez dans les messages de partages et les invitations calendrier.",
	"preset password": "mot de passe",
	"preset password tip": "Un mot de passe fort d'au moins 8 caractères (les caractères spéciaux sont recommandés).",
	"preset timezone": "fuseau horaire",
	"preset timezone tip": "Votre fuseau horaire est utilisé pour afficher correctement les événements dans votre calendrier.",
	"preset opt-in help": "Je souhaite aider Cozy à améliorer la plateforme en transmettant des données statistiques anonymes relatives à mon utilisation.",
	"preset opt-out newsletter": "Je souhaite être informé par Cozy des évolutions du produit (recommandé).",
	"import from google": "importer mes données depuis mon compte Google",
	"import google account": "Synchroniser votre compte Gmail & importer mes calendriers, contacts et photos depuis Google",
	"import google account tip": "Vous devez vous authentifier sur votre compte Google pour autoriser Cozy à accéder aux informations hébergées chez Google",
	"leave google title": "Importez vos données dans Cozy",
	"leave google help me": "Je n'ai pas compris, aidez-moi !",
	"leave google sign in content": "Authentifiez-vous sur votre compte Google pour autoriser votre Cozy à accéder à vos informations. Vous obtiendrez une suite de caractères complexe. Copiez-la.",
	"leave google sign in": "S'authentifier chez Google",
	"leave google code content": "Puis, copiez-collez le code extrait de la popup dans ce champ :",
	"leave google code": "jeton Google",
	"leave google url doc": "https://docs.cozy.io/fr/mobile/import-google.html",
	"leave google choice": "Sélectionnez les données hébergées chez Google à importer :",
	"leave google choice sync gmail": "GMail - Accédez à vos emails depuis Cozy",
	"leave google choice contacts": "Contacts Google - Copier sur mon Cozy",
	"leave google choice calendar": "Calendriers Google - Copier sur mon Cozy",
	"leave google choice photos": "Photos Google - Copier sur mon Cozy",
	"leave google confirm": "Importer les données",
	"import error": "Une erreur s'est produite durant l'importation de vos données. Veuillez réessayer depuis l'application dédiée.",
	"login welcome user": "Bienvenue %{username}",
	"login welcome anon": "Bienvenue",
	"login enter your password": "Entrez votre mot de passe pour accéder à votre Cozy",
	"login password": "mot de passe",
	"login otp": "Code d'authentification",
	"login submit": "Se connecter",
	"login auth success": "Authentification réussie, entrons !",
	"login recover": "Mot de passe oublié ? Envoyez-moi un email de restauration.",
	"login recover busy": "Envoi de l'email contenant la démarche à suivre",
	"login recover sent title": "Email envoyé",
	"login recover sent message": "Un email contenant les instructions pour restaurer votre mot de passe vous a été envoyé.",
	"login recover error title": "Une erreur s'est produite à l'envoi du mail",
	"login recover error message": "Une erreur s'est produite à l'envoi du message de récupération du mot de passe. Veuillez vérifier le bon fonctionnement de votre MTA ou contactez l'administrateur de votre serveur.",
	"login wrong password title": "Mauvais identifiants",
	"login wrong password message": "Le mot de passe que vous avez entré est incorrect. Merci d'essayer de nouveau.",
	"login server error": "Une erreur est survenue, veuillez réessayer.",
	"reset password request success title": "Email envoyé",
	"reset password request success message": "Merci de regarder vos emails et de suivre les instructions pour changer votre mot de passe.",
	"reset password request error": "Une erreur est survenue, le mail n'a pas pu envoyé. Veuillez réessayer. Si l'erreur persiste, contactez notre support à contact@cozycloud.cc.",
	"reset welcome user": "Restauration du mot de passe",
	"reset enter your password": "%{username}, entrez un nouveau mot de passe pour récupérer l'accès à votre Cozy.",
	"reset password": "mot de passe",
	"reset submit": "restaurer votre mot de passe",
	"reset auth success": "mot de passe restauré",
	"reset wrong password title": "Votre mot de passe n'a pas pu être restauré",
	"reset wrong password message": "Le mot de passe que vous avez entré n'est pas correct, ou votre jeton de restauration a expiré.",
	"reset password error invalid key": "Votre requête de changement de mot de passe a expiré. Merci de renouveler l'opération.",
	"reset password error password too weak": "Votre mot de passe est trop simple. Il est recommandé d'utiliser des majuscules, des chiffres, des caractères spéciaux et/ou un mot de passe plus long.",
	"setup title": "Nous préparons votre Cozy…",
	"setup message": "Vous y être presque ! Dans quelques instants vous pourrez accéder à votre Cozy et reprendre le contrôle de vos données.",
	"setup on mobile title": "Synchronisez vos données avec votre Android !",
	"setup on mobile message": "Téléchargez l'app mobile Cozy sur Google Play :",
	"welcome title": "Félicitations ! Vous venez de reprendre le contrôle de vos données !",
	"welcome message": "Avec Cozy, vous pouvez désormais stocker vos données dans votre propre cloud personnel. Contrairement aux autres services cloud, aucune de vos données ne sera analysée ou exploitée !"
};


//////////////////
// WEBPACK FOOTER
// ./app/locales/fr.json
// module id = 41
// module chunks = 0